var map = {
	"./admin/UK/config.json": [
		4330,
		4330
	],
	"./brother_marcus/UK/config.json": [
		957,
		957
	],
	"./brother_marcus_south_ken/UK/config.json": [
		4738,
		4738
	],
	"./honest_burger/UK/config.json": [
		3096,
		3096
	],
	"./lina/UK/config.json": [
		7597,
		7597
	],
	"./moto/UK/config.json": [
		7106,
		7106
	],
	"./pizza_express/UK/config.json": [
		6632,
		6632
	],
	"./pret/UK/config.json": [
		2772,
		2772
	],
	"./sushi_dog/UK/config.json": [
		9578,
		9578
	],
	"./tossed/UK/config.json": [
		1157,
		1157
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3276;
module.exports = webpackAsyncContext;